import React from 'react';
import FlexCredentialActionDelete from './FlexCredentialDeleteAction';
import FlexCredentialEditAction from './FlexCredentialEditAction';
import FlexCredentialDownloadAction from './FlexCredentialDownloadAction';

const FlexCredentialActionColumn = ({
	managementCompanyId,
	caregiverId,
	column,
	credentialCode,
	rowData,
	sameCredentialCount,
	enabledCredentials,
	onSuccess = () => {}
}) => (
	<div className="credential-actions-container">
		{column.renderer === 'edit' &&
			column.actions?.map((action) => {
				// TODO: handle download in the same manner as delete
				if (action.action === 'edit') {
					return (
						<FlexCredentialEditAction
							key={action.action}
							managementCompanyId={managementCompanyId}
							caregiverId={caregiverId}
							rowData={rowData}
							credentialType={credentialCode}
							enabledCredentials={enabledCredentials}
							onSuccess={onSuccess}
							DownloadButton={
								<FlexCredentialDownloadAction
									managementCompanyId={managementCompanyId}
									caregiverId={caregiverId}
									credentialId={rowData.id}
									credentialType={credentialCode}
									fileId={rowData.file_id}
								/>
							}
						/>
					);
				}
				if (action.action === 'download') {
					return (
						<FlexCredentialDownloadAction
							key={action.action}
							managementCompanyId={managementCompanyId}
							caregiverId={caregiverId}
							credentialId={rowData.id}
							credentialType={credentialCode}
							fileId={rowData.file_id}
						/>
					);
				}
				if (action.action === 'delete') {
					return (
						<FlexCredentialActionDelete
							key={action.action}
							actionIdIdentifier={action.identifier}
							managementCompanyId={managementCompanyId}
							caregiverId={caregiverId}
							rowData={rowData}
							credentialType={credentialCode}
							sameCredentialCount={sameCredentialCount}
						/>
					);
				}
				return null;
			})}
	</div>
);

export default FlexCredentialActionColumn;
